// src/profanityFilter.js

// Basic list of substrings to filter (case-insensitive).
// Add more words/patterns as needed. Be cautious with short substrings
// that might unintentionally block legitimate names (e.g., 'ass' in 'class').
// Expanded list of substrings to filter (case-insensitive).
// Grouped roughly from milder to more severe, alphabetized within groups.
// Be cautious with short substrings that might block legitimate words.
// Expanded list of substrings, now primarily space-padded for whole-word matching.
// Case-insensitive. Includes original substrings as a fallback for edge cases.
// List of profane words (no padding needed).
// Case-insensitive matching will be handled by the regex.
const RUDE_WORDS = [
  // --- Milder Swears / Expletives ---
  //'balls',
  'bloody',
  //'bugger',
  'crap',
  //'damn',
  //'damnit', // Variation
  //'goddamn',
  //'heck',
  //'hell',
  //'piss',
  //'pissed', // Variation

  // --- Stronger Swears / Expletives & Variations ---
  'arse',
  //'ass', // Still potentially problematic
  //'asshole',
  //'bastard',
  //'bitch',
  //'bitching', // Variation
  //'bollocks',
  //'bullshit',
  'cock',
  'cocksucker', // Variation
  'cunt',
  'dick',
  'dickhead', // Moved here
  'fuck',
  'fucked', // Variation
  'fucker', // Variation
  'fuckers', // Variation
  'fucking', // Variation
  'fucks', // Variation
  'fucktard', // Variation
  'fuckwit', // Variation
  //'horseshit',
  'motherfucker', // Variation of fuck
  'shit',
  'shits', // Variation
  'shitty', // Variation
  'shitting', // Variation
  'shite',
  // Multi-word - regex needs adjustment if these are common/needed
  // 'son of a bitch',
  //'wank',
  //'wanker', // Variation

  // --- Derogatory Terms / Body Parts / Sexual References ---
  'asshat',
  'bellend',
  'blowjob',
  'boner',
  'clit',
  'cum', // Still potentially problematic
  'cumming', // Variation
  'cuming', // Misspelling
  'douche',
  'douchebag', // Variation
  'handjob',
  'jizz',
  'knob',
  'knobend', // Variation
  'minge',
  'prick',
  'pussy',
  'queef',
  'rimjob',
  'shag',
  'slag',
  'slut',
  'snatch',
  'spunk',
  'thot',
  'tit', // Still potentially problematic
  'tits',
  'twat',
  'whore',

  // --- Slurs / Highly Offensive Terms ---
  // !! WARNING: Highly offensive. Use extreme caution. !!
  'beaner',
  'chink',
  'coon',
  'dyke',
  'fag',
  'faggot',
  'gook',
  'gyp',
  'homo',     // Anti-gay slur
  'kike',
  'kyke',
  'lesbo',
  'negro',
  'nigger',
  'nigga',
  'paki',
  'poofter',  // Anti-gay slur (UK/Commonwealth)
  'retard', // Ableist slur
  'retarded', // Variation
  'spaz', // Ableist slur
  'spic',
  'tranny', // Transphobic slur
  'wetback',
  'wop',
  
  'yid',
];


// Create a single regex for efficiency.
// \b matches word boundaries (start/end of word, space, punctuation).
// 'i' flag makes it case-insensitive.
// We escape special regex characters within words just in case (though unlikely for profanity).
const profanityPattern = new RegExp(
  `\\b(${
    RUDE_WORDS.map(word =>
      // Escape the word, then add the optional 's'
      word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '(?:s)?'
    ).join('|')
  })\\b`,
  'i'
);


/**
 * Checks if a given text contains any prohibited substrings (case-insensitive).
 * @param {string} text The text to check.
 * @returns {boolean} True if a prohibited substring is found, false otherwise.
 */
export function isProfane(text) {
  if (!text) {
    return false;
  }
  const inputText = String(text); // Ensure it's a string

  // Test the input string against the regex pattern
  return profanityPattern.test(inputText);
}
